import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Book, FileText, Users, Mail, PlusCircle } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {}); }, []);

  const cards = [
    { key: "books", label: "Books", icon: Book, to: "/admin/books", color: "#FF6B9D" },
    { key: "posts", label: "Blog Posts", icon: FileText, to: "/admin/posts", color: "#6EC4E8" },
    { key: "subscribers", label: "Subscribers", icon: Users, to: "/admin/subscribers", color: "#FFD93D" },
    { key: "contacts", label: "Messages", icon: Mail, to: "/admin/contacts", color: "#FF8C42" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <span className="font-caveat text-2xl" style={{ color: "#FF6B9D" }}>welcome back</span>
      <h1 className="font-fredoka text-4xl sm:text-5xl mt-1" style={{ color: "#2D3055" }}>Your studio</h1>
      <p className="mt-3 max-w-xl" style={{ color: "#4A4E6D" }}>
        A quiet corner of the internet where you shape your little wonders.
      </p>

      <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map(({ key, label, icon: Icon, to, color }) => (
          <Link to={to} key={key} className="warm-card p-6 hover:-translate-y-1 transition-transform" data-testid={`stat-card-${key}`}>
            <div className="w-11 h-11 rounded-2xl flex items-center justify-center" style={{ background: color, color: "#fff" }}>
              <Icon size={20} />
            </div>
            <p className="mt-4 font-fredoka text-3xl" style={{ color: "#2D3055" }}>{stats ? stats[key] : "—"}</p>
            <p className="text-sm mt-1" style={{ color: "#7E82A1" }}>{label}</p>
          </Link>
        ))}
      </div>

      <div className="mt-12 grid md:grid-cols-2 gap-6">
        <Link to="/admin/books" className="paper-card p-6 flex items-center gap-4 hover:shadow-lg transition-shadow" data-testid="quick-add-book">
          <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: "#FF6B9D", color: "#fff" }}>
            <PlusCircle size={22} />
          </div>
          <div>
            <p className="font-fredoka text-lg" style={{ color: "#2D3055" }}>Add a new book</p>
            <p className="text-sm" style={{ color: "#4A4E6D" }}>Introduce your next little wonder.</p>
          </div>
        </Link>
        <Link to="/admin/posts" className="paper-card p-6 flex items-center gap-4 hover:shadow-lg transition-shadow" data-testid="quick-add-post">
          <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: "#6EC4E8", color: "#fff" }}>
            <PlusCircle size={22} />
          </div>
          <div>
            <p className="font-fredoka text-lg" style={{ color: "#2D3055" }}>Write a blog note</p>
            <p className="text-sm" style={{ color: "#4A4E6D" }}>Share a small essay or news.</p>
          </div>
        </Link>
      </div>
    </div>
  );
}
